import React from "react"
import { fieldPropTypes } from "redux-form"
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Checkbox
} from "@material-ui/core"

export default function FieldMatrix(props) {
  const {
    input: { onBlur, value },
    ...others
  } = props

  const { initialValue, typeSelection } = others

  if (!initialValue) {
    return null
  }

  const { rowLabels, columnLabels, values } = !value ? initialValue : value

  const handleChange = (rowLabel, colLabel) => {
    const currValue = !value ? { ...initialValue } : { ...value }
    const newValue = JSON.parse(JSON.stringify(currValue))
    const newCheckedValue = !newValue.values[rowLabel][colLabel]
    if (newCheckedValue === true) {
      if (typeSelection.indexOf("unique") !== -1) {
        Object.keys(newValue.values).map((row) =>
          Object.keys(newValue.values[row]).map(
            // eslint-disable-next-line no-return-assign
            (col) => (newValue.values[row][col] = false)
          )
        )
      }
      if (typeSelection.indexOf("line") !== -1) {
        Object.keys(newValue.values[rowLabel]).map(
          // eslint-disable-next-line no-return-assign
          (col) => (newValue.values[rowLabel][col] = false)
        )
      }
      if (typeSelection.indexOf("column") !== -1) {
        Object.keys(newValue.values).map(
          // eslint-disable-next-line no-return-assign
          (row) => (newValue.values[row][colLabel] = false)
        )
      }
    }
    newValue.values[rowLabel][colLabel] = newCheckedValue
    onBlur(newValue)
  }

  return (
    <TableContainer style={{ maxWidth: 1400 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ minWidth: 275 }} />
            {columnLabels.map((columnLabel) => (
              <TableCell key={columnLabel}>{columnLabel}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowLabels.map((rowLabel) => (
            <TableRow key={rowLabel}>
              <TableCell>{rowLabel}</TableCell>
              {columnLabels.map((columnLabel) => (
                <TableCell key={columnLabel}>
                  <Checkbox
                    checked={values[rowLabel][columnLabel] || false}
                    onClick={() => handleChange(rowLabel, columnLabel)}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

FieldMatrix.propTypes = {
  ...fieldPropTypes
}
